import { render } from "./SurveyRevisionComments.vue?vue&type=template&id=818d002a"
import script from "./SurveyRevisionComments.vue?vue&type=script&lang=js"
export * from "./SurveyRevisionComments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__